

















import { computed, defineComponent, PropType, toRefs, ref } from '@vue/composition-api';
import { queryToJson } from '@tt4b/ttam-utils';
import { AdgroupFormData, FullNormalFormData, PreviewMaterial, PRODUCT_SPECIFIC_TYPE } from '@tt4b/ttam-enums';
import CreativePreviewer from './../creative-previewer/index';
import PreviewMiddle from './preview-middle/index.vue';
import { usePreviewProduct } from '@tt4b/ttam-hooks';
import numeral from 'numeral';

const separator = (value, format = '0,0.[00]') => numeral(value).format(format);
const formatPrice = price => {
  if (!price) {
    return '';
  }
  // 如果区间是相等的只展示一个
  const [min = '', max = ''] = (price?.price_range || '').split('-');
  const range = min === max ? separator(min) : `${separator(min)}-${separator(max)}`;
  return `${range} ${price?.price_unit}`;
};

const name = 'ttam-psa-preview-compose';
export default defineComponent({
  name,
  components: {
    CreativePreviewer,
    PreviewMiddle,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
    },
    creativeFormData: {
      type: Object as PropType<FullNormalFormData>,
      required: true,
      default: () => ({} as FullNormalFormData),
    },
  },
  setup(props) {
    const { aadvid } = queryToJson();
    const { adgroupData, creativeFormData } = toRefs(props);
    const curDisplayType = ref('');

    const { previewProduct, refreshIndex } = usePreviewProduct({
      creativeFormData,
    });

    const productSpecificType = computed(() => creativeFormData.value.productSpecificType);
    const isSelectProduct = computed(() => productSpecificType.value === PRODUCT_SPECIFIC_TYPE.PRODUCTS);

    const config = computed(() => {
      const configVal = {
        apps: adgroupData.value.inventoryFlow,
        material: {
          type: PreviewMaterial.IMAGE,
          media: {
            type: PreviewMaterial.IMAGE,
            imageUrl: previewProduct.value.picture ?? '',
            posterUrl: previewProduct.value.picture ?? '',
          },
          price: formatPrice(previewProduct.value.price),
          productTitle: previewProduct.value.title,
        },
        otherInfo: {
          aadvid,
        },
        placementControl:
          curDisplayType.value === 'recommend'
            ? {
                tiktokRecommendPsaAds: true,
              }
            : {
                tiktokSearchPsaAds: true,
              },
      };

      return configVal;
    });

    const onChangeDisplayType = (type: string) => {
      curDisplayType.value = type;
    };

    return {
      config,
      refreshIndex,
      onChangeDisplayType,
      isSelectProduct,
    };
  },
});
